export default {
  name: 'ReadoutsCreate',

  computed: {
    readoutsCreateConfig () {
      return {
        title: this.$t('fleet/vehicle.readouts'),
        key: 'readouts',
        tabContent: [
          {
            title: this.$t('fleet/vehicle.readouts'),
            component: this.dynamicColumnsContentComponent,
            showInitialRows: 1,
            showButtons: false,
            key: 'readouts',
            display_props: ['type_id', 'value'],
            headers: [this.$t('fleet/vehicle.readout_type'), this.$t('fleet/vehicle.readout_value')],
            fields: [
              {
                key: 'type_id',
                type: 'autocomplete',
                autocomplete_options: {
                  module: 'fleet',
                  route: 'vehicles/readout-types'
                },
                creatable: true,
                editable: true,
                visible: true
              },
              {
                key: 'value',
                hint: this.$t('fleet/vehicle.readout_hint'),
                creatable: true,
                editable: true,
                visible: true
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
  }
}
